import React, { useState, useEffect, useRef } from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import LangModal from "./LangModal";
import ToolsList from "./ToolsList";
import { useTranslation } from "next-i18next";
import LanguageCountryFlag from "./LanguageCountryFlag";
import styles from "../styles/MegaMenu.module.css";
import { List, ChevronDown, X, ChevronUp } from "react-bootstrap-icons";
import useToolsData from "../hooks/useToolsData";
import Image from "next/image";

const Nav = React.memo(function Nav() {
  const router = useRouter();
  const toolsData = useToolsData();
  const { t } = useTranslation("common");

  const [showModal, setShowModal] = useState(false);
  const [navToggleShow, setNavToggleShow] = useState(false);
  const navMenuRef = useRef(null);

  const handleRouteChange = () => {
    setNavToggleShow(false);
  };

  const handleClickOutside = (event) => {
    if (navMenuRef.current && !navMenuRef.current.contains(event.target)) {
      setNavToggleShow(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    router.events.on("routeChangeComplete", handleRouteChange);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.events]);

  return (
    <>
      <header>
        <div>
          <nav className={`${styles.navigation}`}>
            <Link href="/" className={`${styles.logo}`}>
              <h3 style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <Image
                  src="/logo.webp"
                  alt="iLovePDF Tools Logo"
                  width={140}
                  height={60}
                  priority
                  style={{ objectFit: "contain", display: "block" }}
                  sizes="(max-width: 768px) 120px, 140px"
                />
              </h3>
            </Link>

            <ul
              ref={navMenuRef}
              className={`${styles.nav_menu} ${navToggleShow ? styles.active : ""}`}
            >
              <li className={`${styles.nav_list} ${styles.remove_in_mobile}`}>
                <Link href="/" className={`${styles.nav_link}`}>
                  <span>{t("home_page")}</span>
                </Link>
              </li>

              <li className={`${styles.nav_list} ${styles.remove_in_mobile}`}>
                <Link
                  href={toolsData["MergePDFTool"].href}
                  className={`${styles.nav_link}`}
                  prefetch={false}
                >
                  <span>{toolsData["MergePDFTool"].title}</span>
                </Link>
              </li>

              <li className={`${styles.nav_list} ${styles.remove_in_mobile}`}>
                <Link
                  href={toolsData["CompressPDFTool"].href}
                  className={`${styles.nav_link}`}
                  prefetch={false}
                >
                  <span>{toolsData["CompressPDFTool"].title}</span>
                </Link>
              </li>

              <li
                className={`${styles.nav_list} ${
                  navToggleShow ? styles.nav_list_menu : ""
                }`}
              >
                <div
                  className={`${styles.nav_link} ${styles.remove_in_mobile}`}
                  onClick={() => setNavToggleShow(!navToggleShow)}
                >
                  <span>{t("all_pdf_tools")}</span>
                  {navToggleShow ? <ChevronUp /> : <ChevronDown />}
                </div>
                <div className={`${styles.dropdown}`}>
                  <div className={`${styles.dropdown_inner}`}>
                    {navToggleShow && <ToolsList />}
                  </div>
                </div>
              </li>
            </ul>

            <div className={`${styles.nav_action}`}>
              <div
                className={`${styles.btn_primary}`}
                onClick={() => setShowModal(true)}
              >
                <LanguageCountryFlag locale={router.locale} />
              </div>
              <div
                className={`${styles.nav_toggle}`}
                onClick={() => setNavToggleShow(!navToggleShow)}
              >
                <span style={{ width: 25, height: 25, display: "inline-block" }}>
                  {navToggleShow ? <X size={25} /> : <List size={25} />}
                </span>
              </div>
            </div>
          </nav>
        </div>
      </header>
      {showModal && (
        <LangModal show={showModal} onClose={() => setShowModal(false)} />
      )}
    </>
  );
});

export default Nav;
